import { render, staticRenderFns } from "./EmailShareInDetail.vue?vue&type=template&id=457f0914&scoped=true"
import script from "./EmailShareInDetail.vue?vue&type=script&lang=js"
export * from "./EmailShareInDetail.vue?vue&type=script&lang=js"
import style0 from "./EmailShareInDetail.vue?vue&type=style&index=0&id=457f0914&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457f0914",
  null
  
)

export default component.exports